(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section-header');
    const headerWrapper = headerElement?.querySelector('.header_wrapper');

    if (!headerElement || !headerWrapper) return;

    document.documentElement.style.setProperty('--header-height', headerElement.clientHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerWrapper.clientHeight + 'px');
  })();

  } catch(e) { console.error(e); }
})();
})();
